import React, { ReactElement } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERY, RESET_BUTTON } from '@bucketplace/design-system';

export interface RaffleButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

export function RaffleButton({
  children,
  onClick,
  disabled = false,
}: RaffleButtonProps): ReactElement {
  return (
    <Button
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      { children }
    </Button>
  );
}

const Button = styled.button<{ disabled: boolean }>`
  ${RESET_BUTTON}
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px 16px;
  width: 100%;
  background-color: #222;
  color: #fff;
  font-size: 15px;
  line-height: 15px;
  font-weight: 600;
  border-radius: 4px;

  ${MEDIA_QUERY.min('tablet', css`
    padding: 21px 16px;
    font-size: 18px;
    line-height: 18px;
  `)}

  ${MEDIA_QUERY.min('desktop', css`
    padding: 36px 16px;
    font-size: 30px;
    line-height: 30px;
  `)}

  ${({ disabled }) => disabled && css`
    cursor: not-allowed;
    color: #666666;
  `}
`;
